// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
import $ from 'jquery';
import { loading } from './loading';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!../index.html');
  require('raw-loader!../_main.html');
}
$('.j-video-in source').attr('src', require('../video/entry.mp4'));
$('.j-video-loop source').attr('src', require('../video/loop.mp4'));
// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';
loading();
